import { createBackground } from "../components/Canvas/createCanvasImage";
import * as fabric from "fabric";


function parseCSSGradient(cssGradient) {
  const linearRegex = /linear-gradient\((.*)\)/;
  const matches = cssGradient.match(linearRegex);

  if (!matches) {
    throw new Error("Invalid gradient format");
  }

  const gradientContent = matches[1].split(',');
  const direction = gradientContent[0].trim();
  const colors = gradientContent.slice(1).map((colorStop) => {
    const [color, offset] = colorStop.trim().split(/\s+/);
    return {
      color,
      offset: offset ? parseFloat(offset) / 100 : null,
    };
  });

  return { direction, colors };
}

export function getGradientCoords(direction, canvas) {
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  switch (direction) {
    case "to bottom": return { x1: 0, y1: 0, x2: 0, y2: canvasHeight };
    case "to right": return { x1: 0, y1: 0, x2: canvasWidth, y2: 0 };
    case "to bottom right": return { x1: 0, y1: 0, x2: canvasWidth, y2: canvasHeight };
    case "to top": return { x1: 0, y1: canvasWidth, x2: 0, y2: 0 };
    case "to left": return { x1: canvasWidth, y1: 0, x2: 0, y2: 0 };
    default: return { x1: 0, y1: 0, x2: 0, y2: canvasHeight }; // Default to "to bottom"
  }
}



export async function backgroundCreation(selectedBackground, orientation, fabricCanvasInstanceRef, scale) {
  try {
    // Reset any existing background
    if (fabricCanvasInstanceRef && fabricCanvasInstanceRef.backgroundImage) {
      fabricCanvasInstanceRef.set({ backgroundImage: null });
    }
    if (fabricCanvasInstanceRef && fabricCanvasInstanceRef.backgroundColor) {
      fabricCanvasInstanceRef.set({ backgroundColor: null });
    }

    // Handle image or base type background
    if (selectedBackground && orientation && 
        (selectedBackground[orientation].type === "image" || selectedBackground[orientation].type === "base") && 
        fabricCanvasInstanceRef && scale) {
      
      const backgroundImage = await createBackground(selectedBackground[orientation].value, fabricCanvasInstanceRef, scale);
      if (!backgroundImage) {
        console.error("Failed to create background image");
        return;
      }
      
      // Add and remove transparent rect to force proper rendering
      const transparentRect = new fabric.Rect({
        width: fabricCanvasInstanceRef.width,
        height: fabricCanvasInstanceRef.height,
        fill: 'transparent',
        stroke: 'transparent',
        strokeWidth: 0,
      });

      fabricCanvasInstanceRef.add(transparentRect);
      fabricCanvasInstanceRef.renderAll();
      fabricCanvasInstanceRef.remove(transparentRect);
      fabricCanvasInstanceRef.renderAll();
    } 
    // Handle solid color background
    else if (selectedBackground && orientation && selectedBackground[orientation].type === "color") {
      fabricCanvasInstanceRef.set({ backgroundColor: selectedBackground[orientation].value });
      fabricCanvasInstanceRef.requestRenderAll();
    }
    // Handle gradient background
    else if (selectedBackground && orientation && selectedBackground[orientation].type === "gradient" && fabricCanvasInstanceRef) {
      const cssGradient = selectedBackground[orientation].value;

      try {
        const { direction, colors } = parseCSSGradient(cssGradient);
        const coords = getGradientCoords(direction, fabricCanvasInstanceRef);

        const colorStops = colors.map((colorStop, index) => ({
          offset: colorStop.offset ?? index / (colors.length - 1),
          color: colorStop.color,
        }));

        const gradient = new fabric.Gradient({
          type: 'linear',
          coords,
          colorStops,
        });

        fabricCanvasInstanceRef.set({
          backgroundColor: gradient,
        });

        fabricCanvasInstanceRef.requestRenderAll();
      } catch (error) {
        console.error("Failed to apply gradient:", error);
      }
    }
  } catch (error) {
    console.error("Error in backgroundCreation:", error);
  }
}